<template>
    <div>
        <div :class="classObj" class="global-reference-filter-hook">
            <div class="content">
                <div class="prefix" v-if="areAnyDropdownsShowing">
                    <span>Filter by:</span>
                </div>
                <div class="dropdowns">
                    <div v-for="(reference, index) in nonAssetReferenceFields">
                        <div class="dropdown">
                            <v-select :ref="refName" :color="'accent'" clearable @input="onSelectChange($event, index)"
                                      return-object :items="reference.entries" single-line
                                      :value="getReferenceEntry(index)"
                                      :menu-props="vSelectMenuProps" :label="reference.contentType.name"></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        PUSH_REFERENCE_FILTER_ENTRIES,
        SPLICE_REFERENCE_FILTER_ENTRIES,
        PUSH_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES,
        SPLICE_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES,
        PUSH_REORDER_CONTENT_FILTER_ENTRIES,
        SPLICE_REORDER_CONTENT_FILTER_ENTRIES,
        MODE_REFERENCE_FILTER_DEFAULT,
        MODE_REFERENCE_FILTER_CHOOSE_EXISTING,
        MODE_REFERENCE_FILTER_REORDER,
    } from "../../services/constants"
    import helpers from '../../services/helpers'

    export default {
        name: 'reference-filter',
        props: {
            mode: {
                type: Number,
                default: MODE_REFERENCE_FILTER_DEFAULT
            },
        },
        data: function () {
            return {}
        },
        computed: {
            contentTypes() {
                return this.$store.state.spaceContentTypes
            },
            contentType() {
                let contentTypeIdentifier = ''
                switch (this.mode) {
                    case MODE_REFERENCE_FILTER_CHOOSE_EXISTING:
                        contentTypeIdentifier = this.$store.state.referenceFieldState.contentTypeIdentifier
                        break
                    case MODE_REFERENCE_FILTER_REORDER:
                        contentTypeIdentifier = this.$store.state.reorderContent.contentTypeIdentifier
                        break
                    default:
                        contentTypeIdentifier = this.$store.state.contentDashboardState.selectedContentType
                        break

                }
                if (this.$store.state.spaceContentTypes) {
                    return this.$store.state.spaceContentTypes.find(contentType => {
                        return contentType.identifier === contentTypeIdentifier
                    });
                }
                return null

            },
            pushMutation() {
                switch (this.mode) {
                    case MODE_REFERENCE_FILTER_CHOOSE_EXISTING:
                        return PUSH_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES
                    case MODE_REFERENCE_FILTER_REORDER:
                        return PUSH_REORDER_CONTENT_FILTER_ENTRIES
                    default:
                        return PUSH_REFERENCE_FILTER_ENTRIES
                }
            },
            spliceMutation() {
                switch (this.mode) {
                    case MODE_REFERENCE_FILTER_CHOOSE_EXISTING:
                        return SPLICE_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES
                    case MODE_REFERENCE_FILTER_REORDER:
                        return SPLICE_REORDER_CONTENT_FILTER_ENTRIES
                    default:
                        return SPLICE_REFERENCE_FILTER_ENTRIES
                }
            },
            classObj() {
                return {
                    'choose-existing': this.mode === MODE_REFERENCE_FILTER_CHOOSE_EXISTING
                }
            },
            vSelectMenuProps() {
                return {
                    contentClass: 'reference-filter-global-select-hook'
                }
            },
            nonAssetReferenceFields() {
                if (this.contentType) {
                    return this.contentType.fields.filter(field => {
                        return field.type === 'reference'
                    }).filter(field => {
                        return field.referenceType !== 'asset'
                    }).filter(field => {
                        return !!this.$store.state.spaceContent[field.referenceType]
                    }).map(field => {
                        return {
                            contentType: this.contentTypeByIdentifier(field.referenceType),
                            entries: this.$store.state.spaceContent[field.referenceType].map(entry => {
                                return {
                                    text: helpers.getPrimaryDisplayName(entry),
                                    value: entry.id,
                                    entry: entry,
                                }
                            })
                        }
                    })
                }
                return []
            },
            areAnyDropdownsShowing() {
                return this.nonAssetReferenceFields.length > 0
            },
            referenceEntries() {
                switch (this.mode) {
                    case MODE_REFERENCE_FILTER_CHOOSE_EXISTING:
                        return this.$store.state.referenceFieldState.referenceFilterEntries
                    case MODE_REFERENCE_FILTER_REORDER:
                        return this.$store.state.reorderContent.referenceFilterEntries
                    default:
                        return this.$store.state.contentDashboardState.referenceFilterEntries
                }
            },
            refName() {
                return 'select'
            }
        },
        watch: {
            contentType() {
                this.clearSelects()
            }
        },
        methods: {
            contentTypeByIdentifier(identifier) {
                return this.contentTypes.find(contentType => {
                    return contentType.identifier === identifier
                })

            },
            onSelectChange(evt, index) {
                if (evt) {
                    //      Item was selected
                    //      if there is another entry of the same type, remove it
                    const i = this.referenceEntries.findIndex(entry => {
                        return entry.contentType.identifier === evt.entry.contentType.identifier
                    })
                    if (i > -1) {
                        this.$store.commit(this.spliceMutation, i)
                    }
                    this.$store.commit(this.pushMutation, evt.entry)

                } else {
                    // Select was cleared
                    // find which reference was cleared and remove it from the list
                    if (this.nonAssetReferenceFields[index]) {
                        const identifier = this.nonAssetReferenceFields[index].contentType.identifier
                        const i = this.referenceEntries.findIndex(entry => {
                            return entry.contentType.identifier === identifier
                        })
                        if (i > -1) {
                            this.$store.commit(this.spliceMutation, i)
                        }
                    }
                }
            },
            getReferenceEntry(index) {
                if (this.nonAssetReferenceFields[index]) {
                    const identifier = this.nonAssetReferenceFields[index].contentType.identifier
                    const i = this.referenceEntries.findIndex(entry => {
                        return entry.contentType.identifier === identifier
                    })
                    if (i > -1) {
                        const entry = this.referenceEntries[i]
                        if (entry) {
                            return {
                                text: helpers.getPrimaryDisplayName(entry),
                                value: entry.id,
                                entry: entry,
                            }
                        }

                    }
                }
                return {
                    text: '',
                    value: -1,
                    entry: null,
                }
            },
            clearSelects() {
                if (this.$refs[this.refName]) {
                    this.$refs[this.refName].forEach(ref => {
                        ref.reset()
                    })

                }
            },
            initializeSelectInitialValue() {
                let unwatchFunc = null
                unwatchFunc = this.$watch(
                    function () {
                        if (this.nonAssetReferenceFields.length > 0) {
                            if (this.nonAssetReferenceFields[0].entries.length > 0) {
                                return this.nonAssetReferenceFields[0].entries[0].entry
                            }
                        }
                        return null
                    },
                    function (newVal, oldVal) {
                        if (!oldVal && newVal) {
                            this.$store.commit(this.pushMutation, this.nonAssetReferenceFields[0].entries[0].entry)
                            this.$nextTick(() => {
                                unwatchFunc()
                            })
                        }
                    }, {
                        immediate: true,
                    }
                )
            },
            init() {
                if (this.mode === MODE_REFERENCE_FILTER_REORDER) {
                    this.initializeSelectInitialValue()
                }
            },
        },
        created() {
            this.init()
        }
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .content {
        display: flex;
        align-items: center;
    }

    .prefix {
        margin: 0 5px 0 0;
        font-size: 13px;
        position: relative;
        bottom: 5px;
    }

    .choose-existing {
        margin: 0 0 0 41px;

        .dropdowns {
            margin: 0;
        }

        .prefix {
            bottom: 4px;
        }
    }

    .dropdowns {
        display: inline-flex;
    }

    .dropdown {
        margin: 0 5px 0 0;
    }

</style>
